import { SectionText } from './SectionText';

export type { TypeSectionTextProps } from './types';
export default SectionText;
